export const LOCAL_STORAGE_KEYS = {
    CURRENT_QUEST_COOLDOWN: 'current_quest_cooldown',
    CURRENT_QUEST_ACTION: 'current_quest_action',
    RETRY_TIME_MOTIVATION_SHOWN: 'retry_time_motivation_shown',
    CORRECT_STREAK_COUNT: 'correct_streak_count',
    INCORRECT_STREAK_COUNT: 'incorrect_streak_count',
    PRE_ROUND_COUNTDOWN: 'pre_round_countdown',
};
